import templateStr from 'text!./edit-location.html';

export default (function () {
    return {
        scope: {
            label: '@?',
            readonly: '=?',
            hideInputLabel: '<?',
            explicitErrorMessage: '@?',
            location: '<?',
            changeAction: '&'
        },
        require: '^form',
        template: templateStr,

        controller: ['$scope', 'LocaleService', 'ViewModelService', function ($scope, LocaleService, ViewModelService) {

            console.log('in edit location-->' + $scope.location.addressLine1);
            console.log($scope.location);
            if ($scope.location.phone != undefined) {
                if ($scope.location.phone.value != undefined && $scope.location.phoneExtension.value != undefined) {
                    $scope.location.phone.value = $scope.location.phone.value + 'x' + $scope.location.phoneExtension.value;
                }
            }
            console.log($scope.location);
            /*
            $scope.namedInsuredView = ViewModelService.create($scope.namedInsuredData, 'pc', 'edge.capabilities.policycommon.accountcontact.dto.AccountContactDTO', {
            });
             	if(angular.isUndefined($scope.namedInsuredView.primaryPhoneType.value) || $scope.namedInsuredView.primaryPhoneType.value == '')
            	$scope.namedInsuredView.primaryPhoneType.value = 'mobile';
            $scope.namedInsuredView.subtype.aspects.availableValues = [{code : 'Company'},{code : 'Person'}];*/
            $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9') + ' x ?9?9?9?9';
            $scope.phoneMaskWithoutExt = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');

            $scope.is_usZipCode = function (value) {
                if (value == '' || value == undefined) {
                    $scope.error_exist = false;
                    $scope.location.postalCode.error_exist = false;
                    console.log(value);
                    //console.log("undefined")
                } else {
                    //scope.error_exist = true;
                    console.log(value);
                    var regexp = /^[0-9]{5}(?:-[0-9]{4})?$/;
                    if (value != '' && !regexp.test(value)) {
                        $scope.error_exist = true;
                        $scope.location.postalCode.error_exist = true;
                        //   console.log("if")
                    } else {
                        $scope.error_exist = false;
                        $scope.location.postalCode.error_exist = false;
                        //console.log("else")
                    }
                }
            };

            $scope.$watch('location.postalCode.value', function (value) {
                //console.log("inside")
                //console.log(value);
                $scope.is_usZipCode(value);
            });

            /*//**
             * Phone types
             */ /*
                $scope.phoneTypes = {
                     work: _.find($scope.namedInsuredView.primaryPhoneType.aspects.availableValues, {
                         code: 'work'
                     }),
                     mobile: _.find($scope.namedInsuredView.primaryPhoneType.aspects.availableValues, {
                         code: 'mobile'
                     })
                 };
                $scope.submitEditInsuredForm = (editInsuredForm) => {
                      		editInsuredForm.submitted = true;
                		if (($scope.namedInsuredView.value.subtype === 'Company' && ($scope.namedInsuredView.value.mSFOfficialID_EXT === undefined || $scope.namedInsuredView.value.mSFOfficialID_EXT === '')) || (editInsuredForm.invalid)) {
                   	return;
                   }
                   let work=angular.element('#WorkNumber').val();
                      
                      if(work!=undefined && work!=null && work.trim()!=''){
                      	$scope.namedInsuredView.workNumberExtension=work.split('x')[1].trim().replace(/\D/g, '')
                      	$scope.namedInsuredView.workNumber=work.split('x')[0].trim().replace(/\D/g, '');
                      }
                      
                   
                   $scope.changeAction({data : $scope.namedInsuredView.value});
                };
                */
        }]

    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/EditLocationDirective_MSF/editLocation.js
// module id = 1736
// module chunks = 0